import { Injectable } from '@angular/core';
import { first } from 'lodash-es';

import { TeacherGameShowQuestionChoice } from 'app/core/storage/models/teacher-gameshow-question-choice.model';
import { QuestionWithChoicesModel } from 'app/question/models/question-with-choices.model';
import { QuestionWithRenderedTextModel } from 'app/question/models/question-with-rendered-text.model';

@Injectable({
  providedIn: 'root'
})
export class ManipRenderingService {
  public renderDraggableQuestion(questionResult: QuestionWithChoicesModel): void {
    this.renderDraggableQuestionWithName(questionResult);
  }

  public renderDraggableChoices(questionText: string, questionChoices: TeacherGameShowQuestionChoice[]): void {
    const replaceRegex = /(<kh-(manip-draggable|manip-clickable|integer-input|manip-imageswap|manip-windows|manip-dot-connect|manipulative))/gi;

    if (questionText && questionText.match(replaceRegex)) {
      const choiceQuestionText = first(questionText.match(/<kh-manip-(draggable|clickable|imageswap|windows|dot-connect)(.|\n)+<\/kh-manip-(draggable|clickable|imageswap|windows|dot-connect)>/)) as string;
      if (choiceQuestionText !== undefined) {
        questionChoices.forEach((choice) => {
          choice.RenderQuestion = choiceQuestionText
            .replace(replaceRegex, '$1 [reportMode]="true" ')
            .replace(/ng-model="[^"]*"/, '[value]="Question.AnswerText"');
        });
      }

      const choiceImageSwapQuestionText = questionText.match(/<kh-(integer-input|manip-imageswap)(.|\n)+<\/kh-(integer-input|manip-imageswap)>/);
      if (choiceImageSwapQuestionText) {
        questionChoices.forEach((choice) => {
          choice.RenderQuestion = (first(choiceImageSwapQuestionText) as string)
            .replace(replaceRegex, '$1 [reportMode]="true" ')
            .replace('value="Question.FreeFormAnswers[0]"', 'value="Question.AnswerText"');
        });
      }

      if (questionText.includes('<kh-manipulative>') || questionText.includes('<kh-manipulative ')) {
        questionChoices.forEach((choice) => {
          choice.RenderQuestion = (first(questionText.match(/<kh-(manipulative)(.|\n)+<\/kh-(manipulative)>/)) as string)
            .replace(/<kh-manipulative(?!-)/gi, '<kh-manipulative [reportMode]="true" [sampleAnswer]="Question.SampleAnswer" [answerText]="Question.AnswerText" [answerState]="Question.answerState" ');
        });
      }
    }
  }

  public renderDraggableQuestionText(question: QuestionWithRenderedTextModel): void {
    const replaceRegex = /(<kh-manip-(draggable|clickable|imageswap|dot-connect|scorable))/gi;

    if (question && question.QuestionText
      && (question.QuestionText.match(replaceRegex) || question.QuestionText.includes('<kh-manipulative'))
      && question.QuestionTextRendered) {
      const questionText = question.QuestionTextRendered;

      question.QuestionText = questionText
        .replace(replaceRegex, '$1 [reportMode]="true"')
        .replace(/ng-model="[^"]*"/, '');
    }
  }

  public renderQuestionTextForGameShowAnswers(questionText: string): string {
    const replaceRegex = /(<kh-manip-(draggable|clickable|multiply|windows|dot-connect))/gi;
    const khManipulativeRegex = /(<kh-manipulative(?!-))/gi;

    return questionText
      .replace(replaceRegex, '$1 [sampleAnswer]="Question.FreeFormAnswerText" [reportMode]="true"')
      .replace(khManipulativeRegex, '$1 [reportMode]="true"');
  }

  public renderDraggableQuestionWithName(questionResult: QuestionWithChoicesModel, questionName?: string): void {
    const replaceRegex = /(<kh-(manip-draggable|manip-clickable|integer-input|manip-multiply|manip-windows|manip-dot-connect|manip-scorable))/gi;
    const multiplyRegex = /(<kh-manip-(multiply))/gi;
    const fisRegex = /(<kh-manip-(imageswap))/gi;
    const khManipulativeRegex = /(<kh-manipulative(?!-))/gi;

    if (!questionName) {
      questionName = 'Question';
    }

    if (questionResult.QuestionText.match(fisRegex)) {
      const questionText = questionResult.QuestionText;
      const choiceQuestionText =
        questionText.match(
          /<kh-(manip-clickable|manip-imageswap|integer-input|manip-multiply|manip-windows|manip-dot-connect|manip-scorable)(.|\n)+<\/kh-(manip-clickable|manip-multiply|manip-imageswap|integer-input|manip-windows|manip-dot-connect|manip-scorable)>/
        )?.[0] ?? '';
      questionResult.QuestionChoices.forEach((choice, index) => {
        choice.RenderQuestion = choiceQuestionText
          .replace(replaceRegex, '$1 [reportMode]="true"')
          .replace(replaceRegex, '$1 [disabledInput]="true"')
          .replace(replaceRegex, '$1  ng-model="' + questionName + '.AnswerText"')
          .replace(replaceRegex, '$1 value="Question.AnswerText"');
      });
    }
    else if (questionResult.QuestionText.match(khManipulativeRegex)) {
      questionResult.QuestionChoices.forEach((choice, index) => {
        choice.RenderQuestion = questionResult.QuestionText
          .replace(khManipulativeRegex, '$1 [reportMode]="true" ')
          .replace(khManipulativeRegex, '$1 [answerState]="' + questionName + '.AnswerState"')
          .replace(khManipulativeRegex, '$1 [sampleAnswer]="' + questionName + '.SampleAnswer"')
          .replace(/ng-model="[^"]*"/, 'ng-model="' + questionName + '.AnswerText"');
      });
    }
    else if (questionResult.QuestionText.match(replaceRegex)) {
      const questionText = questionResult.QuestionText;
      const choiceQuestionText = questionText.match(/<kh-manip-(draggable|clickable|multiply|windows|dot-connect|scorable)(.|\n)+<\/kh-manip-(draggable|clickable|multiply|windows|dot-connect|scorable)>/)?.[0] ?? '';

      if (questionResult.QuestionText.match(multiplyRegex)) {
        questionResult.QuestionChoices.forEach((choice) => {
          choice.RenderQuestion = choiceQuestionText
            .replace(replaceRegex, '$1 [reportMode]="true"')
            .replace(/value="[^"]*"/, 'value="Choice.AnswerText"');
        });
      }
      else {
        questionResult.QuestionChoices.forEach((choice, index) => {
          choice.RenderQuestion = choiceQuestionText
            .replace(replaceRegex, '$1 [reportMode]="true"')
            .replace(replaceRegex, '$1  [answerState]="' + questionName + '.AnswerState"')
            .replace(replaceRegex, '$1  [sampleAnswer]="' + questionName + '.SampleAnswer"')
            .replace(/ng-model="[^"]*"/, 'ng-model="' + questionName + '.AnswerText"');
        });
      }
    }
  }
}
